module.exports = __webpack_public_path__ + "img/wechat.842b85a1.jpg";